import { useState } from 'react';
import { getOneHourLater } from '../utils';

export const useFormState = () => {
  const [messageContent, setMessageContent] = useState('');
  const [selectedSize, setSelectedSize] = useState('小');
  const [selectedTextColor, setSelectedTextColor] = useState('白');
  const [selectedBgColor, setSelectedBgColor] = useState('黒');
  const [selectedHospitals, setSelectedHospitals] = useState<string[]>([]);
  const [displayPeriod, setDisplayPeriod] = useState(() => truncateToHourOnly(getOneHourLater()));

  const resetForm = () => {
    setMessageContent('');
    setSelectedSize('小');
    setSelectedTextColor('白');
    setSelectedBgColor('黒');
    setSelectedHospitals([]);
    setDisplayPeriod(truncateToHourOnly(getOneHourLater()));
  };

  return {
    messageContent,
    setMessageContent,
    selectedSize,
    setSelectedSize,
    selectedTextColor,
    setSelectedTextColor,
    selectedBgColor,
    setSelectedBgColor,
    selectedHospitals,
    setSelectedHospitals,
    displayPeriod,
    setDisplayPeriod,
    resetForm
  };
};

/** 日付を時間単位に切り捨て（分・秒・ミリ秒を0にする）*/
const truncateToHourOnly = (date: Date): Date => {
  const fixedDate = new Date(date);
  fixedDate.setMinutes(0);
  fixedDate.setSeconds(0);
  fixedDate.setMilliseconds(0);
  return fixedDate;
};